export default "/_next/static/assets/images/sprite.ad8a81a6f4fda280d5d887c765daeccd.svg";